import { z } from "zod";

export const createAprendizProgramaSchema = z.object({
  idAprendiz: z.number().int().positive(),
  idPrograma: z.number().int().positive(),
  progreso: z.number().int().min(0).max(100).default(0),
});

export type CreateAprendizProgramaInput = z.infer<
  typeof createAprendizProgramaSchema
>;

export const updateAprendizProgramaSchema = createAprendizProgramaSchema.extend(
  {
    id: z.number().int().positive(),
  }
);

export type UpdateAprendizProgramaInput = z.infer<
  typeof updateAprendizProgramaSchema
>;

export const uploadExcelSchema = z.object({
  idPrograma: z.number().int().positive(),
  archivo: z.instanceof(File),
});

export type UploadExcelInput = z.infer<typeof uploadExcelSchema>;
